import BenchlingConfig from 'BenchlingConfig';
import {isSubType, LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {RunQueryState} from 'insights/warehouse/AnalyticsWarehouseTypes';
import {BaseTypedValueType} from 'notebook/tables/TableConstants';
import {TaskColumnMappingInfo} from 'processes/modals/SelectTaskColumnMappingsModal';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

export default function getProcessTaskColumnMappingInfoFromQuery(
  runQueryState: RunQueryState
): Array<TaskColumnMappingInfo> {
  if (runQueryState.status !== AsyncStatus.SUCCESS) {
    return [];
  }
  const sourceColumns: Array<TaskColumnMappingInfo> = [];
  for (const column of runQueryState.data.dataFrame.columns) {
    let columnType: BaseTypedValueType | null = null;
    let columnIds: Array<string> = [];

    if (isSubType(column.type.leafType, LeafType.BIOENTITY)) {
      columnType = BaseTypedValueType.BIOENTITY;
    } else if (isSubType(column.type.leafType, LeafType.STORABLE)) {
      columnType = BaseTypedValueType.STORABLES;
    }

    if (column.type.isList) {
      columnIds = runQueryState.data.dataFrame.rows
        .map((row) => row[column.systemName])
        .flat()
        .filter((id) => id != null) as Array<string>;
    } else {
      columnIds = runQueryState.data.dataFrame.rows
        .map((row) => row[column.systemName])
        .filter((id) => id != null) as Array<string>;
    }

    if (
      columnType != null &&
      columnIds.length > 0 &&
      columnIds.length < BenchlingConfig.WORKFLOWS_MAX_TASKS_PER_TASK_GROUP
    ) {
      sourceColumns.push({
        columnName: column.displayName,
        columnType,
        columnIds,
        hasValues: false,
        shouldFetchPlateInfo: false,
      });
    }
  }
  return sourceColumns;
}
